import { useSessione } from './api/sessione.js';

/**
 * Che cosa apre chi è connesso.
 *
 * Le regole stanno tutte sul server (`crm-api/src/auth/permessi.ts`), che con
 * la sessione manda l'elenco delle sezioni: qui non si decide niente, si
 * chiede soltanto. Il menu nasconde le porte chiuse, le pagine non le aprono,
 * e i rimandi da una pagina all'altra diventano testo semplice quando dall'altra
 * parte c'è una sezione che non si vede.
 *
 * Le sezioni si chiamano come il loro indirizzo: `customers` è `/customers`.
 */
export type Sezione =
  | 'customers'
  | 'suppliers'
  | 'agents'
  | 'leads'
  | 'prospects'
  | 'operators'
  | 'items'
  | 'price-lists'
  | 'negotiations'
  | 'sales-orders'
  | 'documents'
  | 'reference-data'
  | 'integrations'
  | 'settings'
  | 'production';

export function usePuoAprire(): (sezione: Sezione) => boolean {
  const { data: sessione } = useSessione();
  const sezioni = sessione?.user.sections ?? [];
  return (sezione) => sezioni.includes(sezione);
}
